import React from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import { useDeleteFormulaCard } from './hooks';

export const DisableFormulaModal = ({
  onDismiss,
  formula,
  onSuccess,
}: {
  formula: { id: string; name: string } | null;
  onDismiss: () => void;
  onSuccess?: () => void;
}) => {
  const { mutate: deleteFormula, isLoading: isDeleting } = useDeleteFormulaCard();

  const handleDisableConfirm = () => {
    if (!formula) return;
    deleteFormula(
      {
        id: formula.id,
        formulaName: formula.name,
      },
      {
        onSuccess: () => {
          onSuccess?.();
          onDismiss();
        },
      },
    );
  };

  return (
    <Modal
      isOpen={true}
      onDismiss={onDismiss}
      size="small"
      accessibilityLabel="Disable formula confirmation">
      <ModalHeader title={`Disable ${formula?.name || 'formula'}?`} />
      <ModalBody>
        <Text size="medium" color="surface.text.gray.muted">
          Once this formula is disabled, it will no longer be applied to payroll calculations. This
          action cannot be undone.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" justifyContent="flex-end" gap="spacing.4">
          <Button variant="tertiary" isDisabled={isDeleting} onClick={onDismiss}>
            Cancel
          </Button>
          <Button
            color="negative"
            isLoading={isDeleting}
            variant="secondary"
            onClick={handleDisableConfirm}>
            Disable
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
